import React from 'react'
import ProductForm from 'views/shared/ProductForm'
import BSCornmealProduct from 'models/BSCornmealProduct'
import BSCornmealPackage from './BSCornmealPackage'

const productOptions = {
  packagingInfo: <BSCornmealPackage />,
  productTitle: 'Brand Specific Cornmeal',
  model: BSCornmealProduct,
  validCategories: ['16'],
  validSubCategories: ['017BS'],
  brandSpecific: true,
}

const BSCornmeal = () => <ProductForm product={productOptions} />

export default BSCornmeal
